import { useEffect } from 'react';
import * as S from './styles.ts';
import Input, { IInputProps } from '@template/components/Input';
import { Minus, Plus } from '@template/icons';

export interface IncrementButtonProps extends IInputProps {
  value: number;
  setValue: (value: number) => void;
  max?: number;
  min?: number;
}

const IncrementButton = ({
  value,
  setValue,
  min = 1,
  max = 150,
  ...props
}: IncrementButtonProps) => {
  const handleIncrement = (prev: number) => {
    const prevValue = typeof prev === 'string' ? parseInt(prev) : prev;
    const newValue = prevValue >= max ? max : prevValue + 1;
    setValue(newValue);
  };
  const handleDecrement = (prev: number) => {
    const prevValue = typeof prev === 'string' ? parseInt(prev) : prev;
    const newValue = prevValue <= min ? min : prevValue - 1;
    setValue(newValue);
  };

  useEffect(() => {
    if (value < 0) {
      setValue(min);
    }
    if (value > max) {
      setValue(max);
    }
  }, [value]);
  return (
    <Input
      name='Change User Count'
      value={value}
      onChange={setValue}
      startContent={
        <S.ToggleBtn onClick={() => handleDecrement(value)}>
          <Minus />
        </S.ToggleBtn>
      }
      endContent={
        <S.ToggleBtn onClick={() => handleIncrement(value)}>
          <Plus />
        </S.ToggleBtn>
      }
      inputProps={{
        style: {
          textAlign: 'center',
          width: 40,
        },
      }}
      style={{
        width: 'fit-content',
      }}
      type='number'
      ariaLabel='Increment or decrement user count'
      {...props}
    />
  );
};

export default IncrementButton;
